import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import FileManagementControls, {
  checkIsFileServiceFile,
  fileServiceUrlToID,
} from '../../../FileManagementControls';
import { permissions } from '../../../../util/abac';
import { Link } from '@lifeomic/chroma-react/components/Link';
import EnforceABAC from '../../../EnforceABAC';

const contentTypes = {
  audio: 'audio/wave',
};

const messages = defineMessages({
  open: {
    id: 'tableLink.open',
    defaultMessage: 'Open',
  },
});

export const useStyles = makeStyles((theme: Theme) => ({
  fileControlsRoot: {
    justifyContent: 'flex-start',
  },
  link: {
    paddingLeft: theme.spacing(1),
  },
}));

export type TableLinkClasses = GetClasses<typeof useStyles>;

export interface TableLinkOwnProps {
  url: string;
  contentType: string;
}

export type TableLinkProps = TableLinkOwnProps;

const TableLink = (props: TableLinkProps) => {
  const formatMessage = useIntl().formatMessage;
  const classes = useStyles(props);

  const isFileServiceFile = checkIsFileServiceFile(props.url);
  const fileServiceFileId = isFileServiceFile
    ? fileServiceUrlToID(props.url)
    : null;

  if (isFileServiceFile) {
    return (
      <EnforceABAC permission={permissions.downloadFile}>
        <FileManagementControls
          className={classes.fileControlsRoot}
          enableRequestDownloadLink
          enableOpen
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          fileId={fileServiceFileId}
          contentType={props.contentType}
        />
      </EnforceABAC>
    );
  } else if (props.contentType === contentTypes.audio) {
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return <audio src={props.url} controls />;
  } else {
    return (
      <Link to={props.url} className={classes.link} newTab>
        {formatMessage(messages.open)}
      </Link>
    );
  }
};

export default React.memo(TableLink);
